/**
 * Proyecto final de UNA cohorte (M2). Vista server-authoritative: el alumno ve
 * la rúbrica publicada + fecha límite + entrega + nota; el manager designa,
 * publica la rúbrica y fija la fecha. Gateada por `academy.final_project`.
 */
import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { Trophy } from "lucide-solid";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { FinalProjectView } from "@/features/academy/final-project/final-project-view";

function FinalProjectDetailPage() {
  const { t } = useI18n();
  const params = finalProjectDetailRoute.useParams();
  return (
    <PageContainer maxWidth="3xl">
      <PageHeader
        title={t(msg`Final project`)}
        description={t(msg`Your capstone: rubric, deadline and submission`)}
        icon={Trophy}
        backTo="/final-project"
      />
      <div class="mt-4">
        <FinalProjectView cohortId={params().cohortId} />
      </div>
    </PageContainer>
  );
}

export const finalProjectDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/final-project/$cohortId",
  component: withFeatureGate("academy.final_project", FinalProjectDetailPage),
});
